export enum FeedbackStatus {
    DEFAULT = 'default',
    LIKE = 'like',
    DISLIKE = 'dislike',
}